import { useQuery } from "react-query";
import Select from "react-select"

import { getRequests } from "../../../../../MyApi/sb/requests";
import { getEmployes } from "../../../../../MyApi/sb/employes";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addCurrency.module.css";


const EditEmployeRequest = ({
  setRequestId,requestId,employId ,setNote, setEmployId , setHoursCount ,  setAmount ,  setDateFrom, setDaysCount, setTimeTo, setDateTo, setTimeFrom , amount, setImage,  date_from, date_to, time_to,    time_from, image, hours_count ,days_count,note
  
}) => {
const requestQuery = useQuery("getRequests" , getRequests)
const employeQuery = useQuery("getEmployes" ,getEmployes)

  const requests = requestQuery.data?.data || []
  const employes = employeQuery.data?.data || [] 
 
  const defaultRequests = requests.find((option=>option.id===requestId))
  const defaultEmploys = employes.find((option=>option.id===employId))
  const DescriptionIcon = icons.description
  const LevelIcon = icons.levels


  const handleRequestIdChange = (selectedRequest) => {
    const RequestId = selectedRequest ?selectedRequest.id :0
    setRequestId(RequestId);  
  };
  const handleEmployeIdChange = (selectedEmploye) => {
    const employId = selectedEmploye ?selectedEmploye.id :0
        setEmployId(employId);
     
  }; 
  const handleNoteChange =(e)=>{
    const {value} =e.target ;
    setNote(value)
  }
  const handleHoursCountChange =(e)=>{
    const {value} =e.target;
    setHoursCount(value)
  }
  const handleDateFrom =(e)=>{
    const {value} =e.target;
    setDateFrom(value)
  }
  const handleDateTo =(e)=>{
    const {value} =e.target;
    setDateTo(value)
  }
  const handleTimeTo =(e)=>{
    const {value} =e.target;
    setTimeTo(value)
  }
  const handleTimeFrom =(e)=>{
    const {value} =e.target;
    setTimeFrom(value)
  }
  const handleAmountChange =(e)=>{
    const {value} = e.target;
    const doubleAmount = parseFloat(value).toFixed(3)
    setAmount(value)
  }
  const handleDaysCount =(e)=>{
    const {value}= e.target;
    setDaysCount(value)
  }
  const handleImageChange =(e)=>{
    const file =e.target.files[0]
  
    
    setImage(file)
  }
  if(requestQuery.isLoading ||requestQuery.isLoading){
    return <LoadingSpinner/>
  }

 
  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">الطلبات </label>
          {!requestQuery.data ? <div> no data available </div> : 
             <Select
            type="text"
            value={defaultRequests}
            placeholder="اختار الطلبات"
            options={requests}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name}
            onChange={handleRequestIdChange}
         
          />
           }
              
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">الموظفين </label>
           {!employeQuery.data ? <div> no data available </div> : 
            <Select
            type="text"
            placeholder="اختار موظف"
            value={defaultEmploys}
            options={employes}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name_ar}
            onChange={handleEmployeIdChange}
           
          />
            }
              
        </div>
         <div className={classes.formCol}>
          <label htmlFor="">الملاحظات </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <textarea  
            type="textarea"
            placeholder="ادخل  الملاحظه"
            onChange={handleNoteChange}
            value={note}
            className={classes.inputCustom}
          > </textarea> 

        </div>
        <div className={classes.formCol}>
          <label htmlFor="">الكمية </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="number"
            placeholder="ادخل  الكمية"
            onChange={handleAmountChange}
            value={amount}
            className={classes.inputCustom}
         />  
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">الوقت من  </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="time"
            placeholder="ادخل  الوقت من "
            onChange={handleTimeFrom}
            value={time_from}
            className={classes.inputCustom}
         />  
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">الوقت إلي  </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="time"
            placeholder="ادخل  الوقت إلي "
            onChange={handleTimeTo}
            value={time_to}
            className={classes.inputCustom}
         />  
        </div>
       
        <div className={classes.formCol}>
          <label htmlFor="">التاريخ من  </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="date"
            placeholder="ادخل التاريخ من "
            onChange={handleDateFrom}
            value={date_from}
            className={classes.inputCustom}
         />  
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">التاريخ إلي  </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="date"
            placeholder="ادخل التاريخ إلي "
            onChange={handleDateTo}
            value={date_to}
            className={classes.inputCustom}
         />  
        </div>
        <div className={classes.formCol}>
          <label htmlFor="image"> الصورة  </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="file"
           
            placeholder="ادخل الصورة "
            onChange={handleImageChange}          
            className={classes.inputCustom}
         />
         <img src={image} alt="" className="img-fluid"/>  
        </div>
        <div className={classes.formCol}>
          <label htmlFor="hoursCount"> عدد الساعات  </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="number"
            placeholder="ادخل عدد الساعات "
            onChange={handleHoursCountChange}
            value={hours_count}
            className={classes.inputCustom}
         />  
        </div>
        <div className={classes.formCol}>
          <label htmlFor="dayscount"> عدد الايام  </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="number"
            placeholder="ادخل عدد الايام "
            onChange={handleDaysCount}
            value={days_count}
            className={classes.inputCustom}
         />  
        </div>
      </div>
    </div>
  );
};

export default EditEmployeRequest;
